import { Stack } from "@mui/material"
import { colors } from "../../../services/config/colors"
import { desktopMaxWidth } from "../../../services/config/constants"
import { useContext } from "react"
import { MainContext } from "../../../controllers/main"
import Text from "../../global/common/Text"
import Title from "../../global/common/Title"

const TicketsBanner = () => {
  const { user, isMobile } = useContext(MainContext)

  return (
    <Stack
      gap={2}
      direction="row"
      alignItems="center"
      style={{
        width: "100%",
        maxWidth: desktopMaxWidth,
        padding: 16,
        border: `3px solid ${colors.primary}`,
        borderRadius: 24,
      }}
    >
      <img
        src={user?.profileImage}
        width={isMobile ? 42 : 46}
        height={isMobile ? 42 : 46}
        style={{ borderRadius: "100%" }}
      />
      <Stack gap={1} style={{ marginTop: 3 }}>
        <Title fontSize={isMobile ? 14 : 16} color={colors.primary}>
          OTTIENI TICKET
        </Title>
        <Text fontSize={isMobile ? 14 : 16} fontWeight={400}>
          {user?.userTicketPhrase}
        </Text>
      </Stack>
    </Stack>
  )
}

export default TicketsBanner
